module.exports = __webpack_public_path__ + "712a352ba0fa28ccd06fedf15fb592f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/coin.png
// module id = 310
// module chunks = 0